import {axios} from '../services/axios';
export default async function getServiceProfiles({level, id}) {
    try {
        const result = await axios.get(`/serviceprofile/${level}/${id}`);
        return result;
    } catch (e) {
        throw e;
    }
}
